import { Button, Modal } from 'antd';

import type { PackListElement } from 'app/typings/core/admin/packs/packList';

type Props = {
  pkg: PackListElement | null;
  onConfirm: (pkg: PackListElement) => void;
};

export const PublishConfirmModal = ({ pkg, onConfirm }: Props) => (
  <Modal
    open={!!pkg}
    title="This hotel is currently unpublished"
    centered
    closable={false}
    footer={[
      <Button key="save" type="primary" onClick={() => pkg && onConfirm(pkg)}>
        Ok, publish package
      </Button>,
    ]}
  >
    <p>
      This hotel and all associated packages are not searchable nor bookable.
      <br /> You must also publish <strong>{pkg?.hotelName}</strong> to make
      this package available for sale.
    </p>
  </Modal>
);
